import { useNavigate, useLocation } from '@reach/router';
import qs from 'qs';
import { useState, useEffect } from 'react';

import { stringIsNumber, scrollToTop } from '../../utils';

const usePagination = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { page } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const [activePage, setActivePage] = useState(
    // @ts-expect-error TS(2345) FIXME: Argument of type 'string | ParsedQs | string[] | P... Remove this comment to see the full error message
    stringIsNumber(page) ? parseInt(page, 10) : 1
  );

  const isFirstPage = activePage === 1;

  const changePage = (page: $TSFixMe) => {
    scrollToTop();
    navigate(`${location.pathname}?page=${page}`);
  };

  useEffect(() => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'string | ParsedQs | string[] | P... Remove this comment to see the full error message
    if (stringIsNumber(page)) {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'string | ParsedQs | string[] | P... Remove this comment to see the full error message
      setActivePage(parseInt(page, 10));
    }
  }, [page]);

  return { activePage, changePage, isFirstPage };
};
export { usePagination };
